import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserProfile } from '../hooks/useUserProfile';
import { ROUTES } from '@shared/constants/routes.constants';

interface EffectiveAccessGuardProps {
  children: ReactNode;
  /** Códigos de capability (permission de erlia-auth /me). */
  codes: string[];
  requireAll?: boolean;
  fallback?: ReactNode;
  /** Si true, redirige a Home cuando no hay acceso. */
  redirect?: boolean;
}

/**
 * Gate de UI/ruta con AuthZ efectiva (permissions de GET /me).
 */
export const EffectiveAccessGuard: React.FC<EffectiveAccessGuardProps> = ({
  children,
  codes,
  requireAll = false,
  fallback = null,
  redirect = false,
}) => {
  const { isLoading, hasAnyEffectiveAccess, hasAllEffectiveAccess } = useUserProfile();

  if (isLoading) {
    return null;
  }

  const hasAccess = requireAll
    ? hasAllEffectiveAccess(codes)
    : hasAnyEffectiveAccess(codes);

  if (!hasAccess) {
    if (redirect) {
      return <Navigate to={ROUTES.MAIN.HOME} replace />;
    }
    return <>{fallback}</>;
  }

  return <>{children}</>;
};
